<template>
  <div
    id="app"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
  >
    <link v-for="(url, index) in typekitFontUrls" :key="`typekit-font-${index}`" rel="stylesheet" type="text/css" :href="url">
    <v-style v-for="(style, index) in fileFontStyles" :key="`font-${index}`">{{ style }}</v-style>
    <transition
      name="fade"
      mode="out-in"
    >
      <div v-if="$store.state.siteLoaded">
        <mobile-only v-if="!screenIsMobile" />
        <router-view v-else />
        <cookie-banner v-if="showCookieBanner" />
      </div>
      <generic-loader
        v-else
        :fullScreen="true"
        :isBlack="true"
      />
    </transition>
  </div>
</template>

<script>
  import store from '@/store';
  import MobileOnly from '@/components/ui/MobileOnly';
  import GenericLoader from '@/components/ui/GenericLoader';
  import CookieBanner from '@/components/CookieBanner';

  export default {
    name: 'App',
    data () {
      return {
        maxScreenSize: 700
      }
    },
    components: {
      MobileOnly,
      GenericLoader,
      CookieBanner
    },
    mounted() {
      this.$store.dispatch('ui/checkCookieConsent');
    },
    computed: {
      fonts () {
        return [this.$store.getters['ui/getBodyCopyFont'], this.$store.getters['ui/getHeadingFont']];
      },
      fileFontStyles () {
        const fileFonts = this.fonts.filter(fontObject => {
          return this.typeOfFontConfig(fontObject) && this.typeOfFontConfig(fontObject).includes('fileFont');
        });
        return fileFonts.map(font => font.fields && font.fields.fontConfig);
      },
      typekitFontUrls () {
        const typekitFonts = this.fonts.filter(fontObject => {
          return this.typeOfFontConfig(fontObject) && this.typeOfFontConfig(fontObject).includes('typekitFont');
        });
        return typekitFonts.map(font => font.fields && font.fields.linkToStylesheet);
      },
      metaTitle () {
        return this.$store.getters['getMetaTitle'] ||
               this.$store.getters['getBrandName'] ||
               'Order at Table';
      },
      metaDescription () {
        return this.$store.getters['getMetaDescription'] || '';
      },
      screenIsMobile () {
        return window.innerWidth < this.maxScreenSize;
      },
      showCookieBanner () {
        return this.$store.getters['ui/showCookieBanner'];
      }
    },
    methods: {
      typeOfFontConfig (fontObject) {
        return fontObject &&
                fontObject.sys &&
                fontObject.sys.contentType &&
                fontObject.sys.contentType.sys &&
                fontObject.sys.contentType.sys.id;
      }
    },
    head () {
      return {
        title: {
          inner: this.metaTitle,
          separator: ' ',
          complement: ' '
        },
        meta: () => {
          return [
            { hid: 'description', name: 'description', content: this.metaDescription },
            { name: 'theme-color', content: this.$store.getters['ui/getHeaderColor'] },
            { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
            { name: 'apple-mobile-web-app-capable', content: 'yes' },
            { name: 'mobile-web-app-capable', content: 'yes' }
          ]
        }
      };
    }
  };
</script>

<style lang="scss">
  @import '@/assets/scss/site.scss';

  #app {
    .fade-enter-active,
    .fade-leave-active {
      transition-duration: 0.5s;
      transition-property: opacity;
      transition-timing-function: ease;
    }
    .fade-enter,
    .fade-leave-active {
      opacity: 0
    }
  }

</style>
